var path = 'directives/notes/notes.html';
var html = "<div class=\"box full-post datacenter-notes\" ng-if=vm.notes><div class=accordion-wrapper><dl class=accordionShow><dt><a href=\"\"><h5>NOTES</h5></a><a href=\"\" class=\"plus-btn active\"></a></dt><dd id=notes><div ng-repeat=\"(key, group) in vm.notes\"><h6 ng-if=group.val.length>{{ group.name }}</h6><p ng-repeat=\"note in group.val\" ng-bind-html=\"note.Note | markdown\"></p></div></dd></dl></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./js/directives/notes/notes.html
 ** module id = 191
 ** module chunks = 0
 **/